export function getId(value: any): string {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);

  if (typeof value === "object") {
    if ("$oid" in value && typeof (value as any).$oid === "string") return (value as any).$oid as string;
    if ("_id" in value) return getId((value as any)._id);
    if ("id" in value) return getId((value as any).id);

    if (typeof (value as any).toString === "function") {
      const s = (value as any).toString();

      if (typeof s === "string" && s && s !== "[object Object]") return s;
    }
  }

  
return String(value);
}

// Consolidated ID utilities
export const toStringId = (v: any): string => {
  if (!v) return "";
  if (typeof v === "string") return v;

  if (typeof v === "object") {
    const oid = (v as any).$oid ?? (v as any).oid ?? (v as any)._id;

    if (typeof oid === "string") return oid;
  }

  try {
    return String(v);
  } catch {
    return "";
  }
};

export const extractDocId = (doc: any): string => {
  if (!doc) return "";

  const id = (typeof (doc as any)._id === "object"
    ? (doc as any)._id?.$oid ?? (doc as any)._id?.oid ?? (doc as any)._id?._id
    : (doc as any)._id) ?? (doc as any).id;

  
return typeof id === "string" ? id : toStringId(id);
};

export const ensureString = (v: any): string => (v == null ? "" : String(v));
